import { IRefIds } from 'constants/refs';
import { get } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IBatchJob } from './TranslationBatchModel';

export default class TranslationBatchJobModel extends BaseModel<IBatchJob> {
  private dialectId = 0;

  constructor(options: IModelOptions) {
    super(options);
    this.ref = IRefIds.translationUnified;
    this.gridName = 'TranslationBatchJobs';
    this.getGridColumns();
  }

  setDialectId(dialectId: number) {
    this.dialectId = dialectId;
  }

  async getGrid() {
    if (!this.dialectId) {
      return;
    }
    await super.getGrid();
    this.gridData = await get<IBatchJob[]>('/translation-batch', {
      action: 'jobs',
      dialectId: this.dialectId,
    });
    this.loadingGrid = false;
    this.render();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number): Promise<object> {
    const job = this.gridData.find((j) => j.id === itemId);
    return job ?? {};
  }

  async delete() {
    await super.delete();
    const id = this.itemId;
    await get('/translation-batch', { action: 'delete', jobId: id });
    this.itemId = this.NEW_CREATE_ID;
    this.loadingItem = false;
    this.render();
    await this.getGrid();
  }
}
